import cn from 'classnames';
import { forwardRef, HTMLProps } from 'react';
import { SizeType } from '../../types/props';
import s from './textarea.module.css';

export interface TextAreaProps
  extends Omit<HTMLProps<HTMLTextAreaElement>, 'size' | 'defaultValue' | 'label' | 'required'> {
  size?: SizeType;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
  const { size = 'lg', className, disabled, value = '', ...other } = props;

  const textAreaClassNames = cn(s.component, className, s[size], disabled && s.disabled);

  return (
    <textarea
      ref={ref}
      className={textAreaClassNames}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      value={value}
      {...other}
    />
  );
});
